<template>
    <div class="goods_index">
        <div class="shop_top"><shop-top @search_goods="to_search" :subnav_show="false" :change_color="true"></shop-top></div>
        <!-- <div><banner :list="banner_list" height="300px"></banner></div> -->
         <div style="margin:0 auto; text-align: center;"><el-image src="https://www.sckxyy.com/pc/cuxiaobanner.jpg"></el-image></div>


        <div class="goods_list width_center_1200">
            <div class="group_buy" style="min-height:530px;">
                <div class="group_title"><h2>单品团购</h2></div>
                <div class="list">
            <div class="group_product" style="min-heigt:450px;">
   
                <div  class="one_goods goods_list_item" v-for="(v,k) in list" :key="k">
                <dl >
                <router-link :to="'/goods/info/'+v.id" target="_blank">

                <dt v-if="v.imgFront"><img :src="filePath + v.imgFront" :alt="v.name" :title="v.name"></dt>
                <dt v-else><img src="/pc/nopic.png" :alt="v.name" :title="v.name"></dt>

                <dd class="title" :title="v.name">{{v.name}}</dd>

                <dd class="ftitle" v-if="v.companyName" :title="v.companyName">{{v.companyName}}</dd>

                <dd class="parameter">规格:{{v.spec}}</dd>

                <dd class="parameter" v-if="v.exp == '9999-12-30T16:00:00.000+00:00'">效期:-</dd>
                <dd class="parameter" v-else>效期:{{v.exp | formatTime}}</dd>
                <dd class="parameter" v-if="v.selltype == 2 && v.is_ControlSales == false">库存:0</dd>
                <dd class="parameter" v-else-if="v.stock >= 200">库存:充足</dd>
                <dd class="parameter" v-else-if="v.stock < 200">库存:{{v.stock}}</dd>
                <dd class="parameter" v-else>库存:{{v.stock}}</dd>
                <dd  class="parameter">数量:{{v.qty}}</dd>
                <dd class="price" v-if="isLogin == false" :title="会员可见">会员可见</dd>
                <dd class="price" v-else-if="isLogin == true && v.is_ControlSales == false">授权查看</dd>
                <dd class="price" v-else :title="v.price">￥{{v.money.toFixed(2)}}
                    <span>{{v.ormoney.toFixed(2)}}</span>
                    </dd>
                </router-link>
                <dd  class="item-operate">
                <el-input-number v-model="v.unit" v-if="isLogin == false" size="mini" @change="handleChangeMoney(v)" :min="1" :max='v.maximumPurchase' :step="1" disabled></el-input-number>
                <el-input-number v-model="v.unit" v-else size="mini" @change="handleChangeMoney(v)" :min="1" :max='v.maximumPurchase' :step="1" step-strictly></el-input-number>
                <div @click="toLogin()" class="j_addCart addcart" v-if="isLogin == false">请登录</div>
                <div @click="add_cart(v)" class="j_addCart addcart" v-else>立即购买</div>
                </dd>
                </dl>
                </div>


            </div>
                </div>

            </div>
        </div>

        <div class="goods_list width_center_1200">
            <div class="group_buy">
                <div class="group_title"><h2>多品团购</h2>
                </div>
                <div class="lists" v-for="(v,k) in lists" :key="k">
            <div class="group_left">
                <div  class="goods_list_item" v-for="(item,key) in v.list.slice(0, 4)" :key="key">
                <dl >
                <router-link :to="'/goods/info/'+item.id" target="_blank">

                <dt v-if="item.imgFront"><img :src="filePath + item.imgFront" :alt="item.name" :title="item.name"></dt>
                <dt v-else><img src="/pc/nopic.png" :alt="item.name" :title="item.name"></dt>

                <dd class="title" :title="item.name">{{item.name}}</dd>

                <dd class="ftitle" v-if="item.companyName" :title="item.companyName">{{item.companyName}}</dd>

                <dd class="parameter">规格:{{item.spec}}</dd>

                <dd class="parameter" v-if="item.exp == '9999-12-30T16:00:00.000+00:00'">效期:-</dd>
                <dd class="parameter" v-else>效期:{{item.exp | formatTime}}</dd>
                <dd class="parameter" v-if="item.selltype == 2 && item.is_ControlSales == false">库存:0</dd>
                <dd class="parameter" v-else-if="item.stock >= 200">库存:充足</dd>
                <dd class="parameter" v-else-if="item.stock < 200">库存:{{v.stock}}</dd>
                <dd class="parameter" v-else>库存:{{item.stock}}</dd>
                <dd  class="parameter">数量:{{item.miniQty}}</dd>
                <dd class="price" v-if="isLogin == false" :title="会员可见">会员可见</dd>
                <dd class="price" v-else-if="isLogin == true && item.is_ControlSales == false">授权查看</dd>
                <dd class="price" v-else-if="isLogin == true && item.nowprice == null ">￥{{item.price}}</dd>
                <dd class="price" v-else :title="item.price">￥{{item.nowprice}}<span>￥{{item.price}}</span></dd>
                </router-link>
                </dl>
                </div>
               

            </div>
            <div class="group_right">
                <div class="title">团购价:</div>
                <div class="ormoney">原价:<span>￥</span>{{v.ormoney.toFixed(2)}}</div>
                <div class="money"><span>￥</span>{{v.money.toFixed(2)}}</div>
                <div class="num">
                <el-input-number v-if="isLogin == false" v-model="v.num" size="mini" :min="v.minimumPurchase" :max='v.max' :step="1" disabled></el-input-number>
                <el-input-number v-model="v.num" v-else size="mini"  @change="handleChange(v)" :min="v.minimumPurchase" :max='v.max' :step="1" step-strictly></el-input-number>
                    </div>
                <div class="buybtn">
                    <el-button v-if="isLogin == false" type="danger" @click="toLogin()" size="medium" style="width:200px;">请登录</el-button>
                    <el-button v-else @click="add_carts(v)" type="danger" size="medium" style="width:200px;">立即购买</el-button>
                </div>
            </div>
            </div>

            </div>
        </div>


    <el-dialog
      title="立即购买"
      :visible.sync="dialogVisible"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      width="40%">

        <div class="address_chose">
            <div class="address_chose_title">
                选择送货地址&nbsp;&nbsp;<span style="font-size: 14px; font-weight: normal; float: right;"><router-link to="/user/address"><el-button type="primary">添加新收货地址</el-button></router-link></span>
            </div>
            <div class="address_list">
                <ul>
                    <li :class="v.status==3?'red':''" v-for="(v,k) in address_list.slice(0, 4)" :key="k" @click="set_default(v.id)">
                        <!-- <li :class="v.status==3?'red':''" v-for="(v,k) in address_list.slice(0, 3)" :key="k" @click="set_default(v.id)"> -->
                        <div class="receive_name">{{v.contact}} <span>({{v.phone}})</span></div>
                        <div class="area_info">{{v.province}}{{v.city}}{{v.county}}{{v.street}}{{v.address}}</div>
                        <div :class="v.status==3?'is_default_red':'is_default'"><i class="icon iconfont">&#xe611;</i></div>
                    </li>
                </ul>
            </div>

            <!-- <div class="el-table el-table--border">
                <table cellspacing="0" cellpadding="0" border="0" style="width:100%">
                <thead class="has-gutter">
                <tr class="" span="6">
                <th class="is-leaf"><div class="cell">邮费</div></th>
                </tr>
                </thead>
                <tbody>
                <tr class="el-table__row">
                <td>
                    <div class="cell">包邮</div></td>
                </tr>
                </tbody>
                </table>
            </div> -->

            <div class="el-table el-table--border">
                <table cellspacing="0" cellpadding="0" border="0" style="width:100%">
                <thead class="has-gutter">
                <tr class="" span="6">
                <th class="is-leaf"><div class="cell">备注</div></th>
                </tr>
                </thead>
                <tbody>
                <tr class="el-table__row">
                <td>
                    <div class="cell"><el-input v-model="remark" show-word-limit type="textarea"></el-input></div></td>
                </tr>
                </tbody>
                </table>
            </div>

             </div>


      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>


        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <ShopMbar></ShopMbar>
        
        
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import banner from "@/components/home/public/banner.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"
import {formatDate} from '@/utils/date';
export default {
    components: {
        ShopTop,
        ShopFoot,
        banner,
        ShopMbar,
    },
    props: {},
    data() {
      return {
          goods_list:[],
          banner_list:[],
          total_data:0, // 总条数
          page_size:30,
          current_page:1,
          info:{
              promotionid:128, 
              code:1
          },
          loading: false,
          num:1,
          list:{
              money:0.00,
              ormoney:0.00
          },
          lists:{
              money:0.00,
              ormoney:0.00
          },
          address_list:[],
          totalMoney:null,
          money:160,
          filePath:null,
          isLogin:false,
          dialogVisible:false,
          express:2,
          remark:'', // 备注
          promotionid:null, //活动ID
          minimumPurchase:1,
          qty:1, //购买套数
      };
    },
    watch: {
    },
    computed: {},
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    methods: {
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },


         //获取用户登录信息
        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code==200){
                    this.isLogin = true;
                    this.user_info = res.data;
                }else if(res.code == 401){
                    this.isLogin = false;
                }else{
                    this.isLogin = false;
                }

            });
        },

        // 团购
        one_goods:function(){
            // this.info.page = this.current_page;
            // this.info.is_groupbuy = 1;
            this.$get(this.$api.freeShipping,{platId:this.$platId}).then(res=>{
                if(res.code == 200){
                    if(res.data != null){
                        this.list = res.data.singleProduct.list;
                        for (var i = 0; i < this.list.length; i++) {
                            this.list[i].unit = 1;
                            this.list[i].money = res.data.singleProduct.list[i].nowTotalPrice;
                            this.list[i].qty = res.data.singleProduct.list[i].miniQty;
                            this.list[i].ormoney = res.data.singleProduct.list[i].originalTotalPrice;
                            // }
                        }
                        this.lists = res.data.multiProduct;
                        for (var i = 0; i < this.lists.length; i++) {
                            // this.lists[i].unit = 1;
                            this.lists[i].money = res.data.multiProduct[i].totalPrice;
                            this.lists[i].ormoney = res.data.multiProduct[i].originalPrice;
                            // }
                        }
                    }else{
                        this.list = null;
                        this.lists = null;
                    }
                }

            });
        },
        // 多品团购
        // many_goods:function(){
        //     this.$get(this.$api.freeShipping,{promotionid:128, code:1, platId:this.$platId}).then(res=>{
        //         this.page_size = res.data.per_page;
        //         this.total_data = res.data.total;
        //         this.current_page = res.data.current_page;
        //         this.list = res.data.data;
        //     });
        // },

        toLogin(){
            return this.$router.push('/user/login');
        },


        //收货地址列表
        get_address_list:function(){
            this.$get(this.$api.getAddressList).then(res=>{
                this.address_list = res.data;
                // 如果没有设置默认地址则设置一个
                if(this.address_list.length>0){
                    let a = 4;
                    this.address_list.forEach(addressRes=>{
                        if(addressRes.status == 3){
                            this.addressId = addressRes.id;
                            a += 1;
                        }
                    });
                    if(a==4){
                        this.set_default(this.address_list[0].id);
                    }
                }
              
            });
        },

        //设置默认收货地址
        set_default:function(id){
            this.$put(this.$api.setDefaultAddress,[{id:id,status:3}]).then(()=>{
                this.get_address_list();
                return this.$message.success('选择地址成功!');
            });
        },

        //直接购买
        add_cart:function(info){
            this.dialogVisible = true;
            this.get_address_list();
            this.promotionid = info.hid;
            this.qty = info.unit;
        },

        add_carts:function(info){
            this.dialogVisible = true;
            this.get_address_list();
            this.promotionid = info.id;
            this.qty = info.num;

        },


        //单品计算
        handleChangeMoney(value){
            if(value.unit > 1){
                value.money = value.nowTotalPrice*value.unit;
                value.ormoney = value.originalTotalPrice*value.unit;
                value.qty = value.miniQty*value.unit;
            }else{
                value.money = value.nowTotalPrice;
                value.ormoney = value.originalTotalPrice;
                value.qty = value.miniQty*value.unit;
            }
        },

        //多品计算价格
        handleChange(value) {
            if(value.minimumPurchase >= 1){
                value.money = value.totalPrice*value.num;
                value.ormoney = value.originalPrice*value.num;
            }else{
                value.money = value.totalPrice;
                value.ormoney = value.originalPrice;
            }
        },

        handleDialogConfirm:function(){
            //加入购物车
            // console.log('活动ID'+ this.promotionid);
            // console.log('数量'+ this.qty);
            // //下单
            // console.log('地址ID'+ this.addressId);
            // console.log('配送'+ this.express);
            // console.log('备注'+ this.remark);
            this.loading = true;
            // setTimeout(()=>{
            //     this.$message.success('订单创建成功，进入支付页面!');
            //     this.loading = false;
            //     this.dialogVisible = false;
            // },2000);
            //加入购物车返回购物车ID

            //提交订单
            this.$post(this.$api.shopCarId ,
            {
            promoId:this.promotionid,
            num:this.qty,
            platId:this.$platId,
            addressId:this.addressId,
            remark:this.remark
             }
             ).then(res=>{ 
                if(res.code == 500){
                    return this.$message.error(res.message);
                }else{
                setTimeout(()=>{
                    this.diasabledInput=false 
                },2000);
                this.$message.success('订单创建成功，等待支付');
                this.orderId = res.data;
                //this.orderTime = res.data;
                return this.$router.push('/order/chose_pay/'+this.orderId+'?c=0')
                }

            });


        },
        
    },
    created() {
        this.filepath();
        this.get_user_info();
        // this.totalMoney = this.money;
        // this.many_goods();
        this.one_goods();
        // this.get_groupbuy_banner();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.goods_list{
    margin:40px auto;
    .goods_list_item{
        float: left;
        width: 224px;
        height: 400px;
        box-sizing: border-box;
        margin: 0 10px 0 0;
        background: #fff;
        dl{
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: 224px;
            height: 400px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:25px auto 20px auto;
                display: block;
            }
        }
        dl dt img{
            width: 180px;
            height: 180px;
            margin:20px auto 20px auto;
            display: block;
        }
        dl dd{
            font-size: 14px;
            padding: 0 15px;
            width: 194px;
        }
        dl .parameter{
            font-size: 14px;
            color:#666666;
            line-height: 22px;
            height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        dl dd.title{
            color: #000;
            height: 30px;
            line-height: 30px;
            // text-align: center;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 40px;
            text-align: left;
            font-size: 16px;
            overflow: hidden;
            font-weight: bold;
        }
        dl dd.price span{
            font-size: 14px;
            color: #b0b0b0;
            margin-left: 8px;
            text-decoration: line-through;
            font-weight: normal;
            line-height: 40px;
            float:right;
        }
        dl dd span:last-child{
            text-align: right;
        }
        // dl dd span:first-child:hover{
        //     color:#fff;
        //     background: #F56C6C;
        // }
        dl dd span{
            width: 50%;
            display: block;
            // border-top: 1px solid #efefef;
            float: left;
            line-height: 20px;
            text-align: left;
        }
    }
    // .goods_list_item:nth-child(4n){
    //     margin-right: 0;
    // }
    .goods_list_item:last-child{
        margin-right: 0;
    }
    // .goods_list_item:hover{
    //     // border:1px solid #F56C6C;
    // }
    .goods_list_item:hover dl{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
.goods_list_item a:hover .title{
	color:#409EFF;
}
}

</style>

<style scoped>
.group_buy{
    /* border:1px solid #409EFF;
    height: 470px;
    border-radius: 6px; */
    margin-bottom: 15px;
}
.group_buy .list{
    border:1px solid #409EFF;
    min-height: 470px;
    margin-bottom: 15px;
}
.group_buy .lists{
    border:1px solid #409EFF;
    height: 420px;
    margin-bottom: 15px;
}
.group_buy .group_title{
    background: #409EFF;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 4px 4px 0 0;
}
.group_buy .group_title h2{
    font-size: 20px;
    margin-left: 20px;
    color: #fff;
    float: left;
}
.group_buy .group_title span{
    font-size: 14px;
    color: #fff;
    float: right;
    margin-right: 20px;
}
.group_left{
    float: left;
    width: 926px;
    padding: 10px;
    /* border-right: 1px solid #409EFF; */
}
.group_right{
    float: right;
    padding: 10px;
    text-align: center;
    width: 231px;
}
.group_right .title{
    font-size: 16px;
    margin-top: 50px;
}
.group_right .money{
    height: 70px;
    font-size: 45px;
    line-height: 70px;
    color: #F56C6C;
}
.group_right .money span{
    height: 50px;
    font-size: 14px;
    /* margin-right: 5px; */
    color: #F56C6C;
}

.group_right .ormoney{
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: #909399;
    text-decoration:line-through; 
}
.group_right .ormoney span{
    height: 40px;
    font-size: 16px;
    /* margin-right: 5px; */
    color: #909399;
    
}

.group_right .num{
    margin: 10px auto;
}
.group_right .buybtn{
    margin: 10px auto;
}
.group_right .buybtn el-button{
    width: 100%;
}



.group_product{
    width: 1178px;
    height: auto;
    min-height: 400px;
    padding: 10px;
}
.group_product .goods_list .goods_list_item{
    margin: 0 14px 0 0 !important;
}


.one_goods{
    margin:10px 4px 4px 7px !important;
    height: 440px !important;
}
/* .one_goods:first-child, .one_goods:nth-child(6n){
    margin: 0 14px 14px 7px !important;
} */
.one_goods dl{
    height: 440px !important;
    background: #fff;
}
.one_goods dl .addcart{
    width: 88px;
    height: 26px;
    line-height: 26px;
    background: #F56C6C;
    border:1px solid #F56C6C;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
}
.el-input-number--mini{
    width: 100px;
}
</style>


<style lang="scss" scoped>
.address_chose{
    margin-top: 25px;
    font-size: 14px;
    .address_chose_title{
        font-size: 16px;
        clear: both;
        font-weight: bold;
        padding-bottom: 20px;
    }
    .address_list{
        ul:after{
            content:'';
            display: block;
            clear:both;
        }
        margin-bottom:30px; 
        ul li{
            float: left;
            box-sizing: border-box;
            width: 231px;
            height: 105px;
            border-radius: 3px;
            border:2px solid #efefef;
            margin-right: 5px;
            margin-left: 5px;
            margin-bottom: 10px;
            padding:20px;
            position: relative;
            cursor: pointer;
            .receive_name{
                margin-bottom: 10px;
                font-weight: bold;
                line-height: 18px;
                span{
                    font-weight: normal;
                    color:#666;
                    font-size: 12px;
                }
            }
            .area_info{
                color:#666;
            }
            .is_default{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -12px;
            }
            .is_default_red{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -12px;
                color:#F56C6C;
            }
        }
        ul li.red{
            border-color: #F56C6C;
        }
        ul li:nth-child(4n){
            margin-right: 0;
        }
    }
}
.el-table thead th {
    background: #f5f7fa;
}
.el-table p{
    margin: 5px auto;
}
// .el-table td{
//     padding: 10px;
// }
</style>